import type { PageProps } from "../pageProps";
import { LegalView } from "./legal/LegalView";
import { NOTTLDR_PRIVACY } from "./legal/privacy";

export const PrivacyPage = (_props: PageProps) => <LegalView doc={NOTTLDR_PRIVACY} />;
